import { Link } from "react-router-dom";
import { Award, ChevronRight } from "lucide-react";
import { useRedEstado } from "@/lib/red";

export const FoundersCounter = () => {
  const [e] = useRedEstado();
  if (!e) return null;
  const f = e.fundadores;
  return (
    <Link to="/conecta/mi-red" data-testid="hoy-founders-counter" className="c-card p-3 flex items-center gap-3 active:scale-[0.99] transition-transform">
      <Award className="w-5 h-5 text-[#bc9538]" />
      <p className="flex-1 text-sm">{f.agotados ? "Lugares de fundador agotados · lista de espera" : <>Fundadores: <span className="font-bold">{f.asignados} de {f.cupo}</span></>}</p>
      {e.avisos_sin_leer > 0 && <span data-testid="hoy-red-avisos-badge" className="min-w-[20px] h-[20px] px-1 rounded-full bg-[#dc2626] text-white text-[11px] font-bold flex items-center justify-center">{e.avisos_sin_leer}</span>}
      <ChevronRight className="w-4 h-4 c-muted" />
    </Link>
  );
};
